/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "up-dollar"
};
import { etherToWei, weiToEther } from '@/service/format-bignumber';
import { toThousandsString } from '@/utils/account-token/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'up-dollar',
  props: {
    balance: {
      default: ''
    },
    price: {
      default: -1
    },
    decimals: {
      default: 18
    }
  },

  setup(__props) {
    const props = __props;
    const formatDollar = computed(() => {
      if (props.price === -1) {
        return '~';
      }

      const {
        balance,
        price,
        decimals
      } = props;

      try {
        const _decimals = decimals || 18;

        const _balance = etherToWei(balance || '0', _decimals);

        const _price = etherToWei((price || 0).toFixed(18), 18);

        const worth = parseFloat(weiToEther(_balance.mul(_price), 18 + _decimals));
        return `~$${toThousandsString(worth.toFixed(2))}`;
      } catch (error) {
        return '~$0.00';
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(formatDollar)), 1);
    };
  }

});